<template>
	<div class="home">
		<div class="banner">
			<!-- 轮播图加载状态 -->
			<div v-if="bannerLoading" class="loading-placeholder">
				<div class="loading-content">
					<div class="spinner"></div>
					<p>轮播图加载中...</p>
				</div>
			</div>

			<div v-show="!bannerLoading" class="carousel-container" @touchstart="handleTouchStart"
				@touchmove="handleTouchMove" @touchend="handleTouchEnd" @mousedown="handleMouseDown"
				@mousemove="handleMouseMove" @mouseup="handleMouseUp" @mouseleave="handleMouseLeave"
				:class="{ 'dragging': isDragging }">
				<div class="carousel-wrapper">
					<div class="carousel-track" :style="{ 
                            transform: `translateX(calc(-${currentIndex * 100}% + ${dragOffset}px))`,
                            transition: isDragging ? 'none' : 'transform 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94)'
                        }">
						<div v-for="(item, index) in bannerItems" :key="index" class="carousel-item"
							:class="{ 'active': index === currentIndex }"
							:style="{ backgroundImage: `url('${item && item.img ? (baseApiUrl + item.img) : placeholderImgUrl}')` }">
							<div class="banner-overlay"></div>
							<div class="banner-content">
								<h2>{{ item.title }}</h2>
								<p>{{ item.content }}</p>
								<!-- <button v-if="item.buttonText" class="btn btn-secondary" @click="item.action">
									{{ item.buttonText }}
								</button> -->
							</div>
						</div>
					</div>
				</div>
				<!-- 左右切换按钮 -->
				<div class="carousel-controls">
					<button class="carousel-btn carousel-btn-prev" @click="prevSlide" title="上一张">
						<span>‹</span>
					</button>
					<button class="carousel-btn carousel-btn-next" @click="nextSlide" title="下一张">
						<span>›</span>
					</button>
				</div>

				<!-- 指示器 -->
				<!-- <div class="carousel-indicators">
					<button v-for="(item, index) in bannerItems" :key="index" class="indicator"
						:class="{ 'active': index === currentIndex }" @click="goToSlide(index)"
						:title="`切换到第${index + 1}张`"></button>
				</div> -->

				<!-- 自动播放控制 -->
				<!-- 	<div class="carousel-auto-control">
					<button class="auto-play-btn" @click="toggleAutoPlay" :class="{ 'playing': isAutoPlaying }"
						:title="isAutoPlaying ? '暂停自动播放' : '开始自动播放'">
						{{ isAutoPlaying ? '⏸' : '▶' }}
					</button>
				</div> -->
			</div>
		</div>
		<!-- end banner -->

		<ScrollFadeIn direction="up" :distance="150" :duration="1000">
			<div class="index-box">
				<div class="title-index">
					<div class="w">
						<p class="t">知识产权全产业服务机构</p>
						<p class="t2">帮助客户实现无形资产价值管理</p>
					</div>
				</div>
				<div class="w1355">
					<ul>
						<li @click="gosbfw">
							<div class="image">
								<img src="@/assets/images/icon.png" />
							</div>
							<p class="t">知识产权一站式服务</p>
							<div class="item">
								<span>商标设计</span>
								<span>商标注册</span>
								<span>发明专利</span>
								<span>实用新型专利</span>
								<span>外观设计专利</span>
								<span>版权登记</span>
							</div>
							<div class="btn">
								查看详情
							</div>
						</li>

						<li @click="gozlfw">
							<div class="image">
								<img src="@/assets/images/s1.png" />
							</div>
							<p class="t">科创及法律</p>
							<div class="item">
								<span>科技项目申报</span>
								<span>企业法律服务</span>
								<span>技术转移转化</span>
								<span>知识产权保护</span>
								<span>专业融合</span>
								<span>一站式服务</span>
							</div>
							<div class="btn">
								查看详情
							</div>
						</li>

						<li @click="goflfw">
							<div class="image">
								<img src="@/assets/images/s2.png" />
							</div>
							<p class="t">技术转移转化</p>
							<div class="item">
								<span>技术交易相关资讯</span>
								<span>技术交易对接服务</span>
								<span>技术交易登记服务</span>
								<span>技术评估服务</span>
								<span>技术许可服务</span>
								<span>技术转让服务</span>
							</div>
							<div class="btn">
								查看详情
							</div>
						</li>

						<li @click="goxmsb">
							<div class="image">
								<img src="@/assets/images/s3.png" />
							</div>
							<p class="t">产业园区投资及运营</p>
							<div class="item">
								<span>产业园区投资</span>
								<span>园区运营管理</span>
								<span>产业招商服务</span>
								<span>企业孵化支持</span>
								<span>产业策划</span>
								<span>产业合作</span>
							</div>
							<div class="btn">
								查看详情
							</div>
						</li>
					</ul>
				</div>
			</div>
		</ScrollFadeIn>
		<!-- end 第一块 -->

		<div class="index-box2">
			<ScrollFadeIn direction="down" :distance="150" :duration="1000" :delay="300">
				<div class="title-index">
					<div class="w">
						<p class="t">案例展示</p>
						<p class="t2">为客户提供全国范围的知识产权综合服务方案</p>
					</div>
				</div>

				<div class="list">
					<!-- 案例加载状态 -->
					<div v-if="caseLoading" class="loading-placeholder">
						<div class="loading-content">
							<div class="spinner"></div>
							<p>案例加载中...</p>
						</div>
					</div>

					<div v-show="!caseLoading" class="case-carousel-container" @touchstart="handleCaseTouchStart"
						@touchmove="handleCaseTouchMove" @touchend="handleCaseTouchEnd" @mousedown="handleCaseMouseDown"
						@mousemove="handleCaseMouseMove" @mouseup="handleCaseMouseUp" @mouseleave="handleCaseMouseLeave"
						:class="{ 'dragging': caseIsDragging }">

						<div class="case-carousel-wrapper">
							<div class="case-carousel-track" :style="{
								transform: `translateX(calc(-${caseCurrentIndex * movePercentage}% + ${caseDragOffset}px))`,
								transition: caseIsDragging ? 'none' : 'transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)'
							}">
								<div v-for="(item, index) in caseItems" :key="item.id" class="case-item">
									<div class="case-background"
										:style="{ backgroundImage: `url('${item && item.img ? (baseApiUrl + item.img) : placeholderImgUrl}')` }">
										<div class="case-overlay"></div>
										<div class="case-content">
											<h3>{{ item.title }}</h3>
											<!-- <h4>{{ item.content }}</h4> -->
											<!-- <p>{{ item.content }}</p> -->
											<button class="btn-view-more" @click="goCaseDetails(item.id)">查看详情</button>
										</div>
									</div>
								</div>
							</div>
						</div>

						<!-- PC端控制按钮 -->
						<div class="case-controls">
							<button class="case-btn case-btn-prev" @click="prevCaseSlide">
								<span>‹</span>
							</button>
							<button class="case-btn case-btn-next" @click="nextCaseSlide">
								<span>›</span>
							</button>
						</div>

						<!-- 指示器 -->
						<!-- <div class="case-indicators">
						<button v-for="(item, index) in indicatorItems" :key="index" 
							class="case-indicator"
							:class="{ 'active': index === caseCurrentIndex }"
							@click="goToCaseSlide(index)">
						</button>
					</div> -->
					</div>

					<div class="more">
						<div class="btn" @click="goCase">更多案例</div>
					</div>
				</div>
			</ScrollFadeIn>
		</div>
		<!-- end 第二块 -->

		<!-- 		<ScrollFadeIn direction="up" :distance="150" :duration="1000">
			<div class="index-box3">
				<div class="title-index">
					<div class="w">
						<p class="t">专业团队</p>
						<p class="t2">擅长从客户需求及企业特点出发，提供定制化的知识产权服务</p>
					</div>
				</div>
				<div class="w">
					<div class="img">
						<img src="@/assets/images/center2.jpg" />
					</div>
				</div>
			</div>
		</ScrollFadeIn> -->
		<!-- end 第三块 -->

		<div class="index-box4 index-box5">
			<div class="w">
				<div class="left">
					<ScrollFadeIn direction="right" :distance="150" :duration="1000">
						<div class="cont">
							<div class="title">
								<p class="t">祝云辉<br>安徽万硕科技产业(集团)有限公司董事长兼总裁、党支部书记</p>
								<p class="t2">
									安徽省 D 类高层次人才（省域拔尖人才）、享受政府特殊津贴、国家知识产权局专利高端人才、安徽理工大学客座教授、宿州学院客座教授、宿州埇桥区第十一届政协委员。
								<p class="t2">安徽省科学家企业家协会优秀共产党员、创业安徽之星获得者、安徽省企业创新达人、国家知识产权局专利高端人才、 国家高级科技咨询师（国家一级师资方向）、
									国家高级技术经理人、中国管理科学研究院特约研究员、中国管理科学研究院智库专家、中国创新创业大赛安徽总决赛评委、 享受政府特殊津贴、安徽省 D
									类高层次人才、安徽省级大学生职业规划大赛入库评委、安徽省知识产权保护培训师、安徽省科学家企业家协会副会长、安徽省企业发展研究会常务理事、
									安徽省孵化器协会常务理事、安徽省科学家企业家协会优秀共产党员、创业安徽之星获得者、安徽省企业创新达人、安徽理工大学客座教授、宿州学院客座教授、
									第十一届政协委员、第八届青年五四奖章获得者、最美科技工作者、创业英才获得者、知识产权发展联盟常务副理事长兼秘书长。
								</p>
								<p class="t2">祝云辉始终心怀赤诚，坚定拥护党的路线、方针、政策，在深耕科技服务领域的征程中，他以 “让创新更有价值” 为初心，坚守 “以人为本、科技兴企”
									的宗旨，致力于通过专业服务与技术创新，推动创新链与产业链深度融合，为助力高水平科技自立自强、赋能经济高质量发展持续贡献力量。</p>
								</p>
							</div>
							<!-- <div class="btn">查看详情</div> -->
						</div>
					</ScrollFadeIn>
				</div>

				<div class="right">
					<ScrollFadeIn direction="left" :distance="150" :duration="1000">
						<div class="image">
							<img src="@/assets/images/center.jpg" />
						</div>
					</ScrollFadeIn>
				</div>
			</div>
		</div>
		<!-- end 第五块 -->

		<div class="index-box4">
			<div class="w">
				<div class="left">
					<ScrollFadeIn direction="right" :distance="150" :duration="1000">
						<div class="cont">
							<div class="title">
								<p class="t">客户第一·诚信感恩 <br>以人为本·团队协作</p>
								<p class="t2">
									2024年度营业额2.9亿元，全国设立12家全资子公司，员工近300人，其中，博士3人，硕士研究生16人，先后成立了党支部、团支部、妇联、工会和企业科协。
									万硕集团设立了1500万元万硕创投基金，独立运营和在建7家科技企业孵化器及众创空间，拥有76项科技成果、累计完成技术转移转化17.6亿元，培育和辅导高新技术企业、科技型中小企业等4000余家，帮助企业申请各项知识产权12万余项，举办各类科技专题活动、论坛70余场次。
								</p>
							</div>

							<!-- <div class="btn">查看详情</div> -->
						</div>
					</ScrollFadeIn>
				</div>

				<div class="right">
					<ScrollFadeIn direction="left" :distance="150" :duration="1000">
						<ul>
							<li>
								<div class="img">
									<img src="@/assets/images/icon2.png" />
								</div>
								<p>政策扶持</p>
							</li>

							<li>
								<div class="img">
									<img src="@/assets/images/icon3.png" />
								</div>
								<p>场地扶持</p>
							</li>

							<li>
								<div class="img">
									<img src="@/assets/images/icon4.png" />
								</div>
								<p>企业扶持</p>
							</li>

							<li>
								<div class="img">
									<img src="@/assets/images/icon5.png" />
								</div>
								<p>人才扶持</p>
							</li>

							<li>
								<div class="img">
									<img src="@/assets/images/icon6.png" />
								</div>
								<p>项目扶持</p>
							</li>

							<li>
								<div class="img">
									<img src="@/assets/images/icon2.png" />
								</div>
								<p>信息扶持</p>
							</li>
						</ul>
					</ScrollFadeIn>
				</div>
			</div>
		</div>
		<!-- end 第四块 -->

		<div class="index-box6">
			<ScrollFadeIn direction="right" :distance="150" :duration="1000">
				<div class="w">
					<div class="tab">
						<div class="title">资讯动态</div>
						<ul>
							<li v-for="(item,index) in dtList" :key="index" @click="tabFun(index)"
								:class="{active :index == tabIndex}">{{item}}</li>
						</ul>
						<div class="btn" @click="goNews">更多资讯</div>
					</div>

					<!-- 资讯动态加载状态 -->
					<div v-if="newsLoading" class="loading-placeholder">
						<div class="loading-content">
							<div class="spinner"></div>
							<p>资讯加载中...</p>
						</div>
					</div>

					<div v-show="!newsLoading" class="cont">
						<div class="image">
							<div class="img" v-if="dtContent && dtContent.length > 0">
								<img :src="getFirstImageFromContent(dtContent[0])" v-img-fallback />
							</div>
						</div>

						<ul>
							<template v-if="dtContent && dtContent.length > 0">
								<li v-for="(item,index) in dtContent.slice(0, 2)" :key="index"
									@click="goNewsDetails(item.id)">
									<div class="date">{{item.pubDate}}</div>
									<p class="t">{{item.title}}</p>
									<p class="t2">查看详情</p>
								</li>
							</template>
							<template v-else>
								<li class="no-data">
									<p class="t">暂无数据</p>
								</li>
							</template>
						</ul>
					</div>
				</div>
			</ScrollFadeIn>
		</div>
		<!-- end 第六块 -->
		<div class="video">
			<ScrollFadeIn direction="down" :distance="150" :duration="1000">
				<div class="w">
					<div class="title">
						<p class="t">视频展示</p>
					</div>
					<div class="tab-box">
						<div class="left">
							<ul>
								<li v-for="(item,index) in videoType" :key="index" @click="videoTab(index)"
									:class="{active:videoIndex==index}">{{item}}</li>
							</ul>
						</div>
						<div class="right">
							<video v-if="videoItem && videoItem.video" controls preload="metadata" autoplay muted>
								<source :src="`${baseApiUrl}${videoItem.video}`" type="video/mp4">
								您的浏览器不支持视频播放。
							</video>
							<div v-else class="no-video-placeholder">
								<p>暂无视频内容</p>
							</div>
						</div>
					</div>

				</div>
			</ScrollFadeIn>
		</div>


		<div class="index-box7">
			<!-- <ScrollFadeIn direction="left" :distance="150" :duration="1000"> -->
			<div class="w">
				<div class="title-index">
					<div class="w">
						<p class="t">集团荣誉</p>
						<p class="t2">荣耀见证实力，品质铸就辉煌</p>
					</div>
				</div>

				<!-- 集团荣誉加载状态 -->
				<div v-if="honorLoading" class="loading-placeholder">
					<div class="loading-content">
						<div class="spinner"></div>
						<p>荣誉加载中...</p>
					</div>
				</div>

				<div v-show="!honorLoading" class="image-carousel-container">
					<div class="image-carousel-track" :style="{ animation: 'marquee 40s linear infinite' }">
						<div class="image-carousel-item" v-for="(item, index) in carouselImages" :key="index">
							<img loading="eager" decoding="async" :fetchpriority="index < 2 ? 'high' : 'low'"
								width="220" height="165"
								:src="item && item.img ? `${baseApiUrl}${item.img}` : placeholderImgUrl"
								:alt="item && item.alt ? item.alt : 'image'" v-img-fallback
								@load="e => e.target.classList.add('loaded')" />
						</div>
						<!-- 重复图片以实现无缝循环 -->
						<div class="image-carousel-item" v-for="(item, index) in carouselImages"
							:key="'duplicate-' + index">
							<img loading="eager" decoding="async" :fetchpriority="index < 2 ? 'high' : 'low'"
								width="180" height="80"
								:src="item && item.img ? `${baseApiUrl}${item.img}` : placeholderImgUrl"
								:alt="item && item.alt ? item.alt : 'image'" v-img-fallback
								@load="e => e.target.classList.add('loaded')" />
						</div>
					</div>
				</div>

				<div style="text-align: center;margin-top: 50px;">
					<div class="btn" @click="gohonorDetails">
						查看更多
					</div>
				</div>
			</div>
			<!-- </ScrollFadeIn> -->
		</div>
		<!-- end 第七块 -->

		<div class="index-box9">
			<div class="w">
				<div class="title-index">
					<div class="w">
						<p class="t">合作伙伴</p>
					</div>
				</div>

				<div class="view">
					<!-- 合作伙伴加载状态 -->
					<div v-if="partnerLoading" class="loading-placeholder">
						<div class="loading-content">
							<div class="spinner"></div>
							<p>合作伙伴加载中...</p>
						</div>
					</div>

					<!-- 合作伙伴轮播 -->
					<div v-show="!partnerLoading" class="partner-carousel-container">
						<div class="partner-carousel-track" :style="{ animation: 'marquee 40s linear infinite' }">
							<div class="partner-carousel-item" v-for="(item, index) in partnerImages" :key="index">
								<div class="partner-image-wrapper">
									<img :loading="index < 6 ? 'eager' : 'lazy'" decoding="async"
										:fetchpriority="index === 0 ? 'high' : 'low'" width="180" height="80"
										:src="item && item.img ? `${baseApiUrl}${item.img}` : placeholderImgUrl"
										:alt="item && item.alt ? item.alt : 'image'" v-img-fallback
										@load="e => e.target.classList.add('loaded')" />
								</div>
							</div>
							<!-- 重复图片以实现无缝循环 -->
							<div class="partner-carousel-item" v-for="(item, index) in partnerImages"
								:key="'partner-duplicate-' + index">
								<div class="partner-image-wrapper">
									<img :loading="index < 6 ? 'eager' : 'lazy'" decoding="async"
										:fetchpriority="index === 0 ? 'high' : 'low'" width="180" height="80"
										:src="item && item.img ? `${baseApiUrl}${item.img}` : placeholderImgUrl"
										:alt="item && item.alt ? item.alt : 'image'" v-img-fallback
										@load="e => e.target.classList.add('loaded')" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- end 第九块 -->

		<div class="footer">
			<div class="w">
				<div class="logo">
					<img src="@/assets/images/logo.png" />
				</div>

				<div class="tel">
					<div class="title">
						联系方式
					</div>

					<p class="t">
						<img src="@/assets/images/address.png" /><span>安徽省宿州市高新区众创空间产业基地万硕智慧创新产业园Q1栋</span>
					</p>
					<p class="t">
						<img src="@/assets/images/tel.png" /><span>400-600-0557</span>
					</p>
				</div>

				<div class="link">
					<div class="title">
						产品与服务
					</div>

					<p class="t">知识产权服务</p>
					<p class="t">科创及法律服务</p>
					<p class="t">技术转移转化服务</p>
					<p class="t">产业园区投资及运营服务</p>
					<p class="t">智慧园区建设服务</p>
					<p class="t">3D打印机及产品生产销售</p>
					<p class="t">AI智能系统</p>
				</div>

				<div class="wx">
					<div class="title">
						官方微信
					</div>
					<div class="img">
						<img src="@/assets/images/wx.png" />
					</div>
				</div>

				<div class="wx">
					<div class="title">
						微信公众号
					</div>
					<div class="img">
						<img src="@/assets/images/wx2.jpg" />
					</div>
				</div>
			</div>
		</div>
		<!-- end 文件底 -->


		<!-- 回到顶部按钮 -->
		<BackToTop :visibility-height="300" :size="50" background-color="#409eff" hover-background-color="#337ecc"
			:position-right="20" :position-bottom="20" behavior="smooth" tooltip="回到顶部" @click="handleBackToTopClick"
			@scroll-to-top="handleScrollToTop" />
	</div>
</template>

<script>
	import {
		Api
	} from '@/api/index.js'
	import BackToTop from '@/components/BackToTop.vue'
	import ScrollFadeIn from '@/components/ScrollFadeIn.vue'
	import config from '@/config.js' // 导入配置文件

	export default {
		name: 'HomeView',
		components: {
			BackToTop,
			ScrollFadeIn
		},
		data() {
			return {
				baseApiUrl: config.baseURL, // 从配置文件中获取
				placeholderImgUrl: 'data:image/svg+xml;utf8,' + encodeURIComponent(`
					<svg xmlns="http://www.w3.org/2000/svg" width="1200" height="600" viewBox="0 0 1200 600">
						<defs>
							<linearGradient id="bg" x1="0" x2="0" y1="0" y2="1">
								<stop offset="0%" stop-color="#f5f5f5"/>
								<stop offset="100%" stop-color="#e9e9e9"/>
							</linearGradient>
						</defs>
						<rect width="100%" height="100%" fill="url(#bg)"/>
						<!-- centered 200x200 icon -->
						<g transform="translate(500,200)">
							<rect x="0" y="0" width="200" height="200" rx="18" ry="18" fill="none" stroke="#d0d0d0" stroke-width="8"/>
							<circle cx="150" cy="60" r="20" fill="#c7c7c7"/>
							<path d="M20 165 L95 110 L125 135 L155 115 L180 170 L20 170 Z" fill="#c7c7c7"/>
						</g>
					</svg>
				`),
				// 各模块加载状态
				bannerLoading: true,
				caseLoading: true,
				videoLoading: false,
				newsLoading: true,
				honorLoading: true,
				partnerLoading: true,
				videoIndex: 0,
				videoType: ['万硕看点', '活动聚焦', '知产锦囊'],
				currentIndex: 0,
				autoPlayTimer: null,
				isAutoPlaying: true,
				autoPlayInterval: 4000,
				// 拖动相关状态
				isDragging: false,
				startX: 0,
				currentX: 0,
				dragOffset: 0,
				startTime: 0,
				// 案例轮播相关状态
				caseCurrentIndex: 0,
				caseIsDragging: false,
				caseStartX: 0,
				caseDragOffset: 0,
				caseStartTime: 0,
				caseAutoPlayTimer: null,
				caseIsAutoPlaying: true,
				caseAutoPlayInterval: 3000,
				tabIndex: 0, //选项卡索引
				//咨询动态
				dtList: ['公司新闻', '商标政策解读', '项目政策解读', '版权政策解读', '专利政策'],
				dtContent: [{}],
				bannerItems: [],
				// 案例展示数据
				caseItems: [],
				videoItem: null,
				// 图片轮播数据
				carouselImages: [],
				// 合作伙伴图片数据
				partnerImages: [],
				carouselAnimation: null,
				partnerCarouselAnimation: null,
				isCarouselPaused: false,
				isPartnerCarouselPaused: false,
				// 添加防重复加载标志（已废弃，改用各模块独立标志）
				isDataLoaded: false,
				// 添加数据加载锁（已废弃，改用各模块独立标志）
				isDataLoading: false,
				// 各模块独立的加载状态标志
				honorDataLoaded: false,
				partnerDataLoaded: false
			}
		},
		computed: {
			// 计算最大索引（每次切换一个案例）
			maxCaseIndex() {
				return this.caseItems.length - 1;
			},

			// 指示器数量（基于总案例数）
			indicatorItems() {
				return Array.from({
					length: this.caseItems.length
				}, (_, i) => i);
			},

			// 根据屏幕尺寸计算移动百分比
			movePercentage() {
				if (typeof window === 'undefined') return 25;
				const width = window.innerWidth;
				if (width <= 480) return 100; // 小屏手机一次移动100%
				if (width <= 768) return 50; // 平板一次移动50%
				if (width <= 1200) return 33.333; // 中屏一次移动33.333%
				return 25; // PC端一次移动25%
			},
		},

		methods: {
			//资讯详情
			goNewsDetails(id) {
				this.$router.push({
					path: '/details',
					query: {
						id: id,
						category: 'News'
					}
				})
			},
			// 预连接到图片域名，降低建连时延
			preconnectToApi() {
				try {
					const a = document.createElement('a')
					a.href = this.baseApiUrl || ''
					const origin = a.protocol + '//' + a.host
					if (!origin || origin === '//') return
					const addLink = (rel) => {
						const link = document.createElement('link')
						link.rel = rel
						link.href = origin
						document.head.appendChild(link)
					}
					addLink('preconnect')
					addLink('dns-prefetch')
				} catch (e) {}
			},

			// 为前 n 张图片添加 <link rel="preload" as="image" href="...">，加速首帧
			addPreloadLinks(items, limit = 8) {
				try {
					(items || []).slice(0, limit).forEach(item => {
						if (!item || !item.img) return
						const href = `${this.baseApiUrl}${item.img}`
						const link = document.createElement('link')
						link.rel = 'preload'
						link.as = 'image'
						link.href = href
						link.fetchPriority = 'high'
						document.head.appendChild(link)
					})
				} catch (e) {}
			},
			// 预热图片：空闲时预加载并解码前 n 张，减少首次进入可视区的抖动
			prewarmImages(items, limit = 8) {
				try {
					const idle = window.requestIdleCallback || function(cb) {
						return setTimeout(cb, 0)
					}
					idle(() => {
						(items || []).slice(0, limit).forEach(item => {
							if (!item || !item.img) return
							const url = `${this.baseApiUrl}${item.img}`
							const img = new Image()
							img.decoding = 'async'
							img.loading = 'eager'
							img.src = url
							if (img.decode) {
								img.decode().catch(() => {})
							}
						})
					})
				} catch (e) {}
			},
			//集团列表
			honorFun() {
				// 添加防重复加载检查（使用独立标志）
				if (this.honorDataLoaded) return;

				// 设置加载状态
				this.honorDataLoaded = true;

				const params = {
					pageSize: 1000
				};
				return Api.honorApi(params).then(res => {
					this.carouselImages = res.rows
					this.$nextTick(() => {
						this.addPreloadLinks(this.carouselImages, 12)
						this.prewarmImages(this.carouselImages, 12)
					})
				}).catch(error => {
					console.error('获取集团荣誉数据失败:', error)
					this.carouselImages = [] // 设置默认空数组避免页面错误
					// 失败时重置标志，允许重试
					this.honorDataLoaded = false;
				}).finally(() => {
					this.honorLoading = false;
				})
			},
			partnerFun() {
				// 添加防重复加载检查（使用独立标志）
				if (this.partnerDataLoaded) return;

				// 设置加载状态
				this.partnerDataLoaded = true;

				const params = {
					pageSize: 1000
				};
				return Api.partnerApi(params).then(res => {
					this.partnerImages = res.rows
					this.$nextTick(() => {
						this.addPreloadLinks(this.partnerImages, 12)
						this.prewarmImages(this.partnerImages, 12)
					})
				}).catch(error => {
					console.error('获取合作伙伴数据失败:', error)
					this.partnerImages = [] // 设置默认空数组避免页面错误
					// 失败时重置标志，允许重试
					this.partnerDataLoaded = false;
				}).finally(() => {
					this.partnerLoading = false;
				})
			},
			//跳转资讯
			goNews() {
				this.$router.push({
					path: '/news/newsList',
				})
			},
			//跳转案例
			goCase() {
				this.$router.push({
					path: '/caseCenter/khal',
				})
			},
			//跳转商标服务
			gosbfw() {
				this.$router.push({
					path: '/products/sbfw',
				})
			},
			//跳转专利服务
			gozlfw() {
				this.$router.push({
					path: '/products/zlfw',
				})
			},
			//跳转法律服务
			goflfw() {
				this.$router.push({
					path: '/products/flfw',
				})
			},
			//跳转项目申报
			goxmsb() {
				this.$router.push({
					path: '/products/xmsb',
				})
			},
			//视频选项卡
			videoTab(index) {
				if (this.videoIndex !== index) {
					this.videoIndex = index;
					this.videoItem = null;
					this.videoFun();
				}
			},
			//视频
			videoFun() {
				const params = {
					type: this.videoIndex + 1,
				};

				this.videoItem = null;

				return Api.videoApi(params).then(res => {
					if (res && res.rows && res.rows.length > 0 && res.rows[0]) {
						// 确保视频对象存在且有video属性
						const video = res.rows[0];
						if (video.video) {
							this.videoItem = video;
						} else {
							this.videoItem = null;
						}
					} else {
						this.videoItem = null;
					}
				}).catch(error => {
					console.error('获取视频数据失败:', error);
					this.videoItem = null;
				});
			},

			//选项卡
			tabFun(index) {
				this.tabIndex = index
				this.newsLoading = true; // 设置资讯加载状态
				this.newsFun()
			},

			//资讯列表
			newsFun() {
				// 传递type参数和分页参数
				const params = {
					type: this.tabIndex + 1, // type值1-5对应索引0-4
				};

				return Api.newsApi(params).then(res => {
					// 直接使用返回的数据，无需筛选
					this.dtContent = res.rows || [];
				}).catch(error => {
					console.error('获取资讯数据失败:', error);
					this.dtContent = []; // 设置默认空数组避免页面错误
				}).finally(() => {
					this.newsLoading = false;
				})
			},

			// 案例轮播方法
			nextCaseSlide() {
				if (this.caseCurrentIndex < this.maxCaseIndex) {
					this.caseCurrentIndex++;
				} else {
					// 循环回到第一个
					this.caseCurrentIndex = 0;
				}
			},

			prevCaseSlide() {
				if (this.caseCurrentIndex > 0) {
					this.caseCurrentIndex--;
				} else {
					// 循环到最后一个
					this.caseCurrentIndex = this.maxCaseIndex;
				}
			},

			goToCaseSlide(index) {
				this.caseCurrentIndex = Math.max(0, Math.min(index, this.maxCaseIndex));
			},

			// 案例轮播拖动事件处理
			handleCaseTouchStart(e) {
				this.startCaseDrag(e.touches[0].clientX);
			},

			handleCaseTouchMove(e) {
				if (this.caseIsDragging) {
					e.preventDefault();
					this.updateCaseDrag(e.touches[0].clientX);
				}
			},

			handleCaseTouchEnd() {
				this.endCaseDrag();
			},

			handleCaseMouseDown(e) {
				e.preventDefault();
				this.startCaseDrag(e.clientX);
				document.addEventListener('mousemove', this.handleCaseDocumentMouseMove);
				document.addEventListener('mouseup', this.handleCaseDocumentMouseUp);
			},

			handleCaseMouseMove(e) {
				if (this.caseIsDragging) {
					this.updateCaseDrag(e.clientX);
				}
			},

			handleCaseMouseUp() {
				this.endCaseDrag();
			},

			handleCaseMouseLeave() {
				// 鼠标离开时不结束拖动，因为可能在拖动过程中
			},

			handleCaseDocumentMouseMove(e) {
				if (this.caseIsDragging) {
					this.updateCaseDrag(e.clientX);
				}
			},

			handleCaseDocumentMouseUp() {
				this.endCaseDrag();
				document.removeEventListener('mousemove', this.handleCaseDocumentMouseMove);
				document.removeEventListener('mouseup', this.handleCaseDocumentMouseUp);
			},
			// 案例拖动核心逻辑
			startCaseDrag(clientX) {
				this.caseIsDragging = true;
				this.caseStartX = clientX;
				this.caseDragOffset = 0;
				this.caseStartTime = Date.now();

				// 暂停案例自动播放
				if (this.caseIsAutoPlaying) {
					this.stopCaseAutoPlay();
					this._caseWasAutoPlaying = true;
				}
			},

			updateCaseDrag(clientX) {
				if (!this.caseIsDragging) return;
				this.caseDragOffset = clientX - this.caseStartX;
			},

			endCaseDrag() {
				if (!this.caseIsDragging) return;

				const dragDistance = Math.abs(this.caseDragOffset);
				const dragTime = Date.now() - this.caseStartTime;
				const velocity = dragDistance / dragTime;

				// 判断是否切换
				const threshold = 50;
				const velocityThreshold = 0.3;

				if (dragDistance > threshold || velocity > velocityThreshold) {
					if (this.caseDragOffset > 0) {
						// 向右拖动，显示上一个
						this.prevCaseSlide();
					} else {
						// 向左拖动，显示下一个
						this.nextCaseSlide();
					}
				}

				// 重置状态
				this.caseIsDragging = false;
				this.caseDragOffset = 0;
				this.caseStartX = 0;

				// 恢复案例自动播放
				if (this._caseWasAutoPlaying) {
					setTimeout(() => {
						this.startCaseAutoPlay();
						this._caseWasAutoPlaying = false;
					}, 1000);
				}
			},

			// 案例自动播放控制
			startCaseAutoPlay() {
				if (this.caseAutoPlayTimer) {
					this.stopCaseAutoPlay();
				}
				this.caseAutoPlayTimer = setInterval(() => {
					this.nextCaseSlide();
				}, this.caseAutoPlayInterval);
				this.caseIsAutoPlaying = true;
			},

			stopCaseAutoPlay() {
				if (this.caseAutoPlayTimer) {
					clearInterval(this.caseAutoPlayTimer);
					this.caseAutoPlayTimer = null;
				}
				this.caseIsAutoPlaying = false;
			},

			// 轮播相关方法
			nextSlide() {
				if (this.currentIndex < this.bannerItems.length - 1) {
					this.currentIndex++
				} else {
					// 循环到第一张
					this.currentIndex = 0
				}
			},

			prevSlide() {
				if (this.currentIndex > 0) {
					this.currentIndex--
				} else {
					// 循环到最后一张
					this.currentIndex = this.bannerItems.length - 1
				}
			},

			goToSlide(index) {
				this.currentIndex = index
			},

			startAutoPlay() {
				if (this.autoPlayTimer) {
					this.stopAutoPlay()
				}
				this.autoPlayTimer = setInterval(() => {
					this.nextSlide()
				}, this.autoPlayInterval)
				this.isAutoPlaying = true
			},

			stopAutoPlay() {
				if (this.autoPlayTimer) {
					clearInterval(this.autoPlayTimer)
					this.autoPlayTimer = null
				}
				this.isAutoPlaying = false
			},

			toggleAutoPlay() {
				if (this.isAutoPlaying) {
					this.stopAutoPlay()
				} else {
					this.startAutoPlay()
				}
			},

			// 鼠标事件处理
			handleMouseEnter() {
				if (this.isAutoPlaying) {
					this.stopAutoPlay()
					this._wasAutoPlaying = true
				}
			},

			handleMouseLeave() {
				if (this._wasAutoPlaying) {
					this.startAutoPlay()
					this._wasAutoPlaying = false
				}
			},

			// 触摸事件处理
			handleTouchStart(e) {
				this.startDrag(e.touches[0].clientX);
			},

			handleTouchMove(e) {
				if (this.isDragging) {
					e.preventDefault();
					this.updateDrag(e.touches[0].clientX);
				}
			},

			handleTouchEnd() {
				this.endDrag();
			},

			// 鼠标事件处理
			handleMouseDown(e) {
				e.preventDefault();
				this.startDrag(e.clientX);
				document.addEventListener('mousemove', this.handleDocumentMouseMove);
				document.addEventListener('mouseup', this.handleDocumentMouseUp);
			},

			handleMouseMove(e) {
				if (this.isDragging) {
					this.updateDrag(e.clientX);
				}
			},

			handleMouseUp() {
				this.endDrag();
			},

			handleDocumentMouseMove(e) {
				if (this.isDragging) {
					this.updateDrag(e.clientX);
				}
			},

			handleDocumentMouseUp() {
				this.endDrag();
				document.removeEventListener('mousemove', this.handleDocumentMouseMove);
				document.removeEventListener('mouseup', this.handleDocumentMouseUp);
			},

			// 拖动核心逻辑
			startDrag(clientX) {
				this.isDragging = true;
				this.startX = clientX;
				this.currentX = clientX;
				this.dragOffset = 0;
				this.startTime = Date.now();

				// 暂停自动播放
				if (this.isAutoPlaying) {
					this.stopAutoPlay();
					this._wasAutoPlaying = true;
				}
			},

			updateDrag(clientX) {
				if (!this.isDragging) return;

				this.currentX = clientX;
				this.dragOffset = this.currentX - this.startX;
			},

			endDrag() {
				if (!this.isDragging) return;

				const dragDistance = Math.abs(this.dragOffset);
				const dragTime = Date.now() - this.startTime;
				const velocity = dragDistance / dragTime;

				// 判断是否切换幻灯片
				const threshold = 50; // 最小拖动距离
				const velocityThreshold = 0.3; // 速度阈值

				if (dragDistance > threshold || velocity > velocityThreshold) {
					if (this.dragOffset > 0) {
						// 向右拖动，显示上一张
						this.prevSlide();
					} else {
						// 向左拖动，显示下一张
						this.nextSlide();
					}
				}

				// 重置拖动状态
				this.isDragging = false;
				this.dragOffset = 0;
				this.startX = 0;
				this.currentX = 0;

				// 恢复自动播放
				if (this._wasAutoPlaying) {
					setTimeout(() => {
						this.startAutoPlay();
						this._wasAutoPlaying = false;
					}, 1000);
				}
			},

			// 处理窗口尺寸变化
			handleResize() {
				// 不再强制更新，避免无限刷新
				// this.$forceUpdate();
			},

			// 回到顶部按钮事件处理
			handleBackToTopClick() {
				console.log('回到顶部按钮被点击')
			},

			handleScrollToTop() {
				console.log('已滚动到顶部')
			},
			//轮播接口
			bannerFun() {
				return Api.bannerApi().then(res => {
					this.bannerItems = res.rows
				}).catch(error => {
					console.error('获取轮播图数据失败:', error)
					// 错误已在request.js中统一处理，这里可以添加额外的处理逻辑（如显示默认数据）
					this.bannerItems = [] // 设置默认空数组避免页面错误
				}).finally(() => {
					this.bannerLoading = false;
				})
			},
			//案例列表
			casesFun() {
				return Api.casesApi().then(res => {
					this.caseItems = res.rows
				}).catch(error => {
					console.error('获取案例数据失败:', error)
					// 错误已在request.js中统一处理，这里可以添加额外的处理逻辑（如显示默认数据）
					this.caseItems = [] // 设置默认空数组避免页面错误
				}).finally(() => {
					this.caseLoading = false;
				})
			},
			// 暂停图片轮播
			pauseCarousel() {
				this.isCarouselPaused = true;
			},

			// 恢复图片轮播
			resumeCarousel() {
				this.isCarouselPaused = false;
			},

			// 暂停合作伙伴轮播
			pausePartnerCarousel() {
				this.isPartnerCarouselPaused = true;
			},

			// 恢复合作伙伴轮播
			resumePartnerCarousel() {
				this.isPartnerCarouselPaused = false;
			},

			//案例详情
			goCaseDetails(id) {
				this.$router.push({
					path: '/details',
					query: {
						id: id,
						category: 'Case'
					}
				})
			},
			//荣誉详情Group honor
			gohonorDetails() {
				this.$router.push({
					path: '/honor'
				})
			},
			// 从富文本中提取第一个图片的路径
			getFirstImageFromContent(item) {
				if (!item || !item.content) {
					return this.placeholderImgUrl;
				}

				// 使用正则表达式匹配<img>标签中的src属性
				const imgRegex = /<img[^>]*src=["']([^"']*)["'][^>]*>/i;
				const match = item.content.match(imgRegex);

				if (match && match[1]) {
					// 检查是否是相对路径，如果是则拼接baseApiUrl
					if (match[1].startsWith('http') || match[1].startsWith('//')) {
						return match[1];
					} else {
						// 如果是相对路径，拼接基础API URL
						return `${this.baseApiUrl}${match[1]}`;
					}
				}

				// 如果没有找到图片，返回默认占位图
				return this.placeholderImgUrl;
			},

			// 串行加载所有数据，避免并发请求过多
			async loadAllData() {
				// 防止重复加载
				if (this.isDataLoaded) {
					return;
				}

				this.isDataLoaded = true;

				try {
					// 依次加载各个模块数据，避免并发请求过多
					await this.bannerFun();
					await this.casesFun();

					// 首次加载只调用第一个视频（万硕看点）
					this.videoIndex = 0;
					await this.videoFun();

					await this.newsFun();
					await this.honorFun();
					await this.partnerFun();
				} catch (error) {
					console.error('数据加载过程中出现错误:', error);
				}
			}
		},

		mounted() {
			// 启动自动播放
			this.startAutoPlay()
			this.startCaseAutoPlay()

			// 串行加载所有数据，避免并发请求过多导致的问题
			this.loadAllData();

			// 使用 $nextTick 确保 DOM 更新完成后再查询元素
			this.$nextTick(() => {
				// 添加鼠标事件监听
				if (this.$el && typeof this.$el.querySelector === 'function') {
					const carousel = this.$el.querySelector('.carousel-container')
					if (carousel) {
						carousel.addEventListener('mouseenter', this.handleMouseEnter)
						carousel.addEventListener('mouseleave', this.handleMouseLeave)
					}

					// 案例轮播鼠标悬停控制
					const caseCarousel = this.$el.querySelector('.case-carousel-container')
					if (caseCarousel) {
						caseCarousel.addEventListener('mouseenter', () => {
							if (this.caseIsAutoPlaying) {
								this.stopCaseAutoPlay();
								this._caseWasAutoPlaying = true;
							}
						})
						caseCarousel.addEventListener('mouseleave', () => {
							if (this._caseWasAutoPlaying) {
								this.startCaseAutoPlay();
								this._caseWasAutoPlaying = false;
							}
						})
					}
				}
			});

			// 监听窗口尺寸变化
			window.addEventListener('resize', this.handleResize)

			// 改为纯 CSS 动画，无需 JS 循环
		},

		beforeDestroy() {
			// 清理定时器
			this.stopAutoPlay()
			this.stopCaseAutoPlay()

			// 移除事件监听
			if (this.$el && typeof this.$el.querySelector === 'function') {
				const carousel = this.$el.querySelector('.carousel-container')
				if (carousel) {
					carousel.removeEventListener('mouseenter', this.handleMouseEnter)
					carousel.removeEventListener('mouseleave', this.handleMouseLeave)
				}
			}

			// 清理拖动相关的事件监听
			document.removeEventListener('mousemove', this.handleDocumentMouseMove);
			document.removeEventListener('mouseup', this.handleDocumentMouseUp);
			document.removeEventListener('mousemove', this.handleCaseDocumentMouseMove);
			document.removeEventListener('mouseup', this.handleCaseDocumentMouseUp);

			// 移除窗口尺寸变化监听
			window.removeEventListener('resize', this.handleResize)

			// 清理图片轮播动画
			if (this.carouselAnimation) {
				cancelAnimationFrame(this.carouselAnimation);
			}

			// 清理合作伙伴轮播动画
			if (this.partnerCarouselAnimation) {
				cancelAnimationFrame(this.partnerCarouselAnimation);
			}
		}
	}
</script>

<style lang="scss" scoped>
	/* 全局关键帧，确保动画在作用域样式中可用 */
	@keyframes marquee {
		0% {
			transform: translateX(0);
		}

		100% {
			transform: translateX(-50%);
		}
	}

	.video {
		padding: 80px 0;

		.title {
			font-size: 34px;
			text-align: center;
			font-weight: bold;
			margin-bottom: 60px;
		}

		.tab-box {
			display: flex;
			flex-wrap: wrap;

			.left {
				width: 200px;

				ul li {
					font-size: 18px;
					font-weight: bold;
					cursor: pointer;
					text-align: center;
					line-height: 50px;
					margin-bottom: 20px;
					-moz-transition: all .1s linear;
					-webkit-transition: all .1s linear;
					transition: all .1s linear;
					border-radius: 5px;

					&.active {
						background-color: #409EFF;
						color: #fff;
					}

					&:hover {
						background-color: #409EFF;
						color: #fff;
					}
				}
			}

			.right {
				flex: 1;
				margin-left: 40px;
				min-height: 600px;

				video {
					width: 100%;
					height: auto;
					max-height: 600px;
					object-fit: cover;
					border-radius: 8px;
					box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
				}

				.loading-placeholder {
					width: 100%;
					height: 600px;
					background-color: #f5f5f5;
					border-radius: 8px;
					box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
					display: flex;
					align-items: center;
					justify-content: center;

					.loading-content {
						display: flex;
						flex-direction: column;
						align-items: center;
						justify-content: center;

						p {
							margin: 10px 0 0 0;
							font-size: 18px;
							color: #666;
						}
					}
				}
			}
		}
	}

	/* 视频切换过渡效果 */
	.video-fade-enter-active,
	.video-fade-leave-active {
		transition: opacity 0.3s, transform 0.3s;
	}

	.video-fade-enter {
		opacity: 0;
		transform: translateX(30px);
	}

	.video-fade-leave-to {
		opacity: 0;
		transform: translateX(-30px);
	}

	.index-box8 {
		margin-bottom: 80px;

		ul {
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;

			li {
				width: 32%;

				.hot {
					display: flex;
					flex-wrap: wrap;
					cursor: pointer;
					margin-bottom: 40px;
					padding-bottom: 40px;
					border-bottom: 1px solid #ddd;

					&:hover {
						.text .t {
							color: #007bff;
						}
					}

					.image {
						width: 45%;

						.img {
							position: relative;
							padding-bottom: 64.4%;
							overflow: hidden;

							img {
								position: absolute;
								width: 100%;
								height: 100%;
								object-fit: cover;
								display: block;
								width: 100%;
								height: 100%;
								transition: all 0.7s;

								&:hover {
									transform: scale(1.1);
								}
							}
						}
					}

					.text {
						flex: 1;
						margin-left: 20px;

						.t {
							font-size: 16px;
							display: -webkit-box;
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 2;
							overflow: hidden;
						}

						.t2 {
							font-size: 14px;
							color: #999;
							margin-top: 10px;
						}
					}
				}

				dl dd {
					font-size: 16px;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 1;
					overflow: hidden;
					margin-bottom: 15px;
					cursor: pointer;

					&:hover {
						color: #007bff;
					}

					i {
						vertical-align: 1px;
						display: inline-block;
						width: 10px;
						height: 10px;
						border-radius: 50%;
						background-color: #ddd;
						margin-right: 10px;
					}
				}
			}
		}
	}

	.index-box7 {
		background: url(../assets/images/bg4.jpg) center no-repeat;
		background-size: cover;
		padding: 20px 0 80px;

		.btn {
			padding: 10px 30px;
			font-size: 18px;
		}

		.title-index {
			color: #fff;
		}
	}

	.index-box6 {
		background: url(../assets/images/bg3.jpg) repeat;
		padding: 100px 0;

		.loading-placeholder {
			flex: 1;
			margin-top: 40px;
		}

		.w {
			display: flex;
			flex-wrap: wrap;
		}

		.tab {
			width: 25%;

			.title {
				font-size: 34px;
				font-weight: bold;
				margin-bottom: 30px;
			}

			ul {
				padding-bottom: 50px;
				border-bottom: 1px solid #ddd;
				margin-bottom: 30px;
				width: 64%;
			}

			ul li {
				width: 130px;
				text-align: center;
				font-size: 16px;
				cursor: pointer;
				line-height: 36px;
				margin-bottom: 10px;

				&:hover {
					background-color: #007bff;
					color: #fff;
				}

				&.active {
					background-color: #007bff;
					color: #fff;
				}
			}

			.btn {
				width: 64%;
				text-align: center;
				line-height: 30px;
				font-size: 18px;

				&:hover {
					background-color: #007bff;
					color: #fff;
				}
			}
		}

		.cont {
			flex: 1;
			display: flex;

			.image {
				width: 37%;
				overflow: hidden;

				.img {
					position: relative;
					// padding-bottom: 133%;
					height: 100%;

					img {
						position: absolute;
						width: 100%;
						height: 100%;
						object-fit: cover;
						display: block;
						width: 100%;
						height: 100%;
						transition: all 0.7s;

						&:hover {
							transform: scale(1.1);
						}
					}
				}
			}

			ul {
				flex: 1;
				display: flex;
				flex-wrap: wrap;
				margin-left: 20px;

				li {
					width: 100%;
					background-color: #fff;
					padding: 20px;
					box-sizing: border-box;
					cursor: pointer;
					transition: all 0.3s ease;
					box-sizing: border-box;
					height: 205px;

					.date {
						font-size: 14px;
					}

					.t {
						font-size: 20px;
						font-weight: bold;
						margin: 20px 0;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 2;
						line-clamp: 2;
						overflow: hidden;
					}

					.t2 {
						font-size: 14px;
					}

					&:first-child {
						margin-bottom: 30px;
					}

					&:hover {
						background-color: #007bff;
						color: #fff;
						-moz-box-shadow: 0 10px 15px rgba(0, 0, 0, .2);
						-webkit-box-shadow: 0 10px 15px rgba(0, 0, 0, .2);
						box-shadow: 0 10px 15px rgba(0, 0, 0, .2);
						-moz-transform: translateY(-5px);
						-webkit-transform: translateY(-5px);
						transform: translateY(-5px);
					}
				}

				.no-data {
					width: 100%;
					background-color: #fff;
					padding: 20px;
					box-sizing: border-box;
					text-align: center;
					height: 205px;
					display: flex;
					align-items: center;
					justify-content: center;

					.t {
						font-size: 18px;
						color: #999;
						margin: 0;
					}
				}
			}
		}
	}

	.index-box4 {
		background: url(../assets/images/bg2.jpg) center no-repeat;
		background-size: cover;
		padding: 100px 0;

		.w {
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;
			align-items: center;
		}

		.left {
			width: 60%;

			.cont {
				width: 77.7%;

				.title {
					color: #fff;
					text-align: left;
					border-bottom: 1px solid rgba(255, 255, 255, .5);
					padding-bottom: 50px;
					margin-bottom: 50px;

					.t {
						font-size: 35px;
						font-weight: bold;
						margin-bottom: 40px;
					}

					.t2 {
						font-size: 16px;
						margin-top: 10px;
						line-height: 32px;
						text-indent: 32px;
					}
				}

				.btn {
					padding: 10px 30px;
					font-size: 18px;

					&:hover {
						background-color: #007bff;
						color: #fff;
					}
				}
			}
		}

		.right {
			flex: 1;

			ul {
				display: flex;
				flex-wrap: wrap;
				justify-content: space-between;

				li {
					width: 32%;
					color: #fff;
					font-size: 18px;
					text-align: center;

					p {
						margin-top: 48px;
					}

					&:nth-child(n+4) {
						margin-top: 100px;
					}

					.img img {
						transition: all 0.3s ease;
					}

					&:hover .img img {
						transform: rotate(360deg);
					}
				}
			}
		}
	}

	.index-box5 {
		background: transparent !important;

		.left {
			.cont {
				width: 90%;

				.title {
					color: #333;
					border-bottom: 1px solid #ddd;
				}
			}
		}

		.right {
			height: 100%;
			width: 35%;
			flex: none;

			.image {
				position: relative;
				padding-bottom: 150%;

				img {
					position: absolute;
					width: 100%;
					height: 100%;
					object-fit: cover;
				}
			}
		}
	}

	.index-box3 {
		margin-bottom: 100px;

		.img {
			position: relative;
			overflow: hidden;
			display: block;

			&:before {
				position: absolute;
				top: 0px;
				left: -80%;
				display: block;
				content: "";
				width: 40%;
				height: 100%;
				overflow: hidden;
				background: -moz-linear-gradient(left, rgba(255, 255, 255, 0), rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, 0));
				background: -webkit-linear-gradient(left, rgba(255, 255, 255, 0), rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, 0));
				background: -webkit-gradient(linear, left top, right top, from(rgba(255, 255, 255, 0)), color-stop(50%, rgba(255, 255, 255, .2)), to(rgba(255, 255, 255, 0)));
				background: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, 0));
				-moz-transform: skewX(-25deg);
				-webkit-transform: skewX(-25deg);
				transform: skewX(-25deg);
			}

			&:hover:before {
				-moz-transition: left 1s ease 0s;
				-webkit-transition: left 1s ease 0s;
				transition: left 1s ease 0s;
				left: 140%;
			}
		}
	}

	.title-index {
		.w {
			font-size: 35px;
			font-weight: bold;
			text-align: center;
			padding: 60px 0;
		}

		.t2 {
			font-size: 16px;
			font-weight: normal;
			margin-top: 10px;
		}
	}

	.index-box2 {
		background: url('@/assets/images/bg1.jpg') center no-repeat;
		background-size: cover;
		padding: 30px 0 80px 0;
		position: relative;

		// &::before {
		// 	content: '';
		// 	position: absolute;
		// 	top: 0;
		// 	left: 0;
		// 	right: 0;
		// 	bottom: 0;
		// 	background: rgba(0, 0, 0, 0.1);
		// 	z-index: 1;
		// }

		.title-index,
		.list {
			position: relative;
			z-index: 2;
		}

		.title-index {
			text-align: center;

			.t {
				color: #fff;
				margin-bottom: 15px;
			}

			.t2 {
				color: #fff;
				margin: 0 auto;
			}
		}

		.case-carousel-container {
			position: relative;
			width: 100vw;
			margin-left: calc(-50vw + 50%);
			padding: 0 20px;
			cursor: grab;
			user-select: none;

			&:active,
			&.dragging {
				cursor: grabbing;
			}
		}

		.case-carousel-wrapper {
			overflow: hidden;
			border-radius: 15px;
		}

		.case-carousel-track {
			display: flex;
			width: 100%;
		}

		.case-item {
			flex: 0 0 25%; // PC端一屏显示4个
			position: relative;
			height: 400px;
			border-radius: 15px;
			overflow: hidden;
			margin: 0 15px;
			box-sizing: border-box;

			.case-background {
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				background-size: cover;
				background-position: center;
				background-repeat: no-repeat;
				transition: transform 0.3s ease;
			}

			.case-overlay {
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				background: linear-gradient(135deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.3));
				z-index: 1;
			}

			.case-content {
				position: absolute;
				bottom: 0;
				left: 0;
				right: 0;
				padding: 40px;
				color: #fff;
				z-index: 2;
				text-align: center;

				h3 {
					font-size: 2rem;
					font-weight: 700;
					margin-bottom: 10px;
					text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
				}

				h4 {
					font-size: 1.2rem;
					font-weight: 500;
					color: #ffd700;
					margin-bottom: 15px;
					text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 3;
					overflow: hidden;
				}

				p {
					font-size: 1rem;
					line-height: 1.6;
					margin-bottom: 25px;
					opacity: 0.9;
					text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
				}

				.btn-view-more {
					background: linear-gradient(45deg, #007bff, #0056b3);
					color: #fff;
					border: none;
					padding: 12px 30px;
					border-radius: 25px;
					font-size: 1rem;
					font-weight: 500;
					cursor: pointer;
					transition: all 0.3s ease;
					box-shadow: 0 4px 15px rgba(0, 123, 255, 0.3);

					&:hover {
						transform: translateY(-2px);
						box-shadow: 0 6px 20px rgba(0, 123, 255, 0.4);
					}
				}
			}

			&:hover .case-background {
				transform: scale(1.05);
			}
		}

		// 控制按钮
		.case-controls {
			position: absolute;
			top: 50%;
			left: 20px;
			right: 20px;
			transform: translateY(-50%);
			display: flex;
			justify-content: space-between;
			pointer-events: none;
			z-index: 10;
		}

		.case-btn {
			width: 50px;
			height: 50px;
			border: 2px solid rgba(255, 255, 255, 0.8);
			background: rgba(255, 255, 255, 0.9);
			color: #333;
			border-radius: 50%;
			cursor: pointer;
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 24px;
			font-weight: bold;
			transition: all 0.3s ease;
			pointer-events: auto;
			backdrop-filter: blur(10px);

			&:hover:not(:disabled) {
				background: #fff;
				transform: scale(1.1);
				box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
			}

			&:disabled {
				opacity: 0.4;
				cursor: not-allowed;
				pointer-events: none;
			}

			span {
				line-height: 1;
			}
		}

		// 指示器
		.case-indicators {
			display: flex;
			justify-content: center;
			gap: 10px;
			margin-top: 30px;
		}

		.case-indicator {
			width: 12px;
			height: 12px;
			border-radius: 50%;
			border: 2px solid rgba(255, 255, 255, 0.6);
			background: transparent;
			cursor: pointer;
			transition: all 0.3s ease;

			&.active {
				background: #fff;
				border-color: #fff;
				transform: scale(1.3);
			}

			&:hover {
				border-color: #fff;
				transform: scale(1.1);
			}
		}

		.more {
			text-align: center;
			margin-top: 50px;

			.btn {
				padding: 10px 40px;
				background-color: transparent;
				color: #fff;
				font-size: 18px;

				&:hover {
					background-color: #007bff;
				}
			}
		}
	}

	.index-box9 {
		padding-bottom: 80px;
	}

	// 案例轮播响应式设计
	@media (max-width: 1200px) {
		.w {
			width: 90% !important;
		}

		.index-box2 {
			.case-carousel-container {
				padding: 0 15px;
			}

			.case-item {
				flex: 0 0 33.333%; // 平板端显示3个
				height: 380px;
				margin: 0 10px;
			}

			.case-controls {
				left: 15px;
				right: 15px;
			}
		}
	}

	@media (max-width: 768px) {
		.index-box4 .right ul li .img img {
			width: 30%;
		}

		.video {
			.title {
				margin-bottom: 30px;
				font-size: 22px;
			}

			.tab-box .left,
			.tab-box .right {
				width: 100%;
				flex: none;
			}

			.tab-box .right {
				margin: 0 auto;
				margin-top: 30px;
				min-height: auto;

				video {
					width: 100%;
					height: auto;
					max-height: 400px;
				}

				.loading-placeholder {
					width: 100%;
					height: 400px;
					background-color: #f5f5f5;
					border-radius: 8px;
					display: flex;
					align-items: center;
					justify-content: center;

					.loading-content {
						display: flex;
						flex-direction: column;
						align-items: center;
						justify-content: center;

						p {
							margin: 10px 0 0 0;
							font-size: 16px;
							color: #666;
						}
					}
				}

				.no-video-placeholder {
					height: 400px;
				}

				.no-video-placeholder p {
					font-size: 16px;
				}
			}
		}

		.index-box8 {
			margin-bottom: 40px;

			ul li {
				.hot {
					margin-bottom: 20px;
					padding-bottom: 20px;
				}

				width: 100%;
				margin-bottom: 40px;

				&:last-child {
					margin-bottom: 0;
				}
			}
		}

		.index-box7 {
			.btn {
				padding: 6px 20px;
				font-size: 14px;
			}
		}

		.index-box6 {
			padding: 40px 0;

			.tab {
				width: 100%;
				text-align: center;
				margin-bottom: 40px;

				.title {
					font-size: 22px;
				}

				.btn {
					width: auto;
					padding: 6px 20px;
					font-size: 14px;
				}

				ul {
					width: 100%;
					padding-bottom: 30px;

					li {
						display: inline-block;
						width: auto;
						padding: 3px 8px;
						font-size: 14px;
					}
				}
			}

			.cont {
				flex: none;
				width: 100%;
				display: block;

				.image {
					width: 100%;
					margin-bottom: 20px;

					.img {
						padding-bottom: 0;

						img {
							height: 200px;
							position: relative;
							width: 100%;
						}
					}
				}

				ul {
					width: 100%;
					flex: none;
					margin-left: 0;

					li {
						height: auto;
					}

					li .t {
						font-size: 16px;
						font-weight: normal;
					}
				}
			}
		}

		.index-box3 {
			margin-bottom: 40px;
		}

		.index-box2 .more .btn {
			font-size: 14px;
		}

		.index-box4 {
			padding: 30px 0;

			.title {
				margin-bottom: 30px !important;
				padding-bottom: 30px !important;

				.t {
					font-size: 22px;
					padding: 30px 0;
				}

				.t2 {
					font-size: 14px;
					margin-top: 0;
				}
			}

			.left,
			.right {
				width: 100%;
			}

			.left .cont {
				width: 100%;

				.title {
					.t {
						margin-bottom: 0;
						font-size: 22px;
						padding: 20px 0;
					}

					.t2 {
						font-size: 14px;
						text-indent: 28px;
					}
				}

				.btn {
					padding: 6px 20px;
					font-size: 14px;
				}
			}

			.right ul li {
				margin-top: 30px !important;

				p {
					margin-top: 20px;
				}
			}
		}

		.index-box5 {
			.left {
				order: 2;
			}

			.right {
				order: 1;
			}
		}

		.index-box2 {
			.case-carousel-container {
				padding: 0 10px;
			}

			.case-item {
				flex: 0 0 50%; // 移动端显示2个
				height: 350px;
				margin: 0 8px;

				.case-content {
					padding: 25px 15px;

					h3 {
						font-size: 1.4rem;
					}

					h4 {
						font-size: 0.95rem;
					}

					p {
						font-size: 0.85rem;
						margin-bottom: 18px;
					}

					.btn-view-more {
						padding: 8px 20px;
						font-size: 0.85rem;
					}
				}
			}

			.case-controls {
				display: none; // 移动端隐藏控制按钮
			}
		}
	}

	@media (max-width: 480px) {
		.index-box2 {
			.case-carousel-container {
				padding: 0 5px;
			}

			.case-item {
				flex: 0 0 100%; // 小屏移动端显示1个
				height: 300px;
				margin: 0 5px;

				.case-content {
					padding: 20px 12px;

					h3 {
						font-size: 1.2rem;
					}

					h4 {
						font-size: 0.85rem;
					}

					p {
						font-size: 0.75rem;
						margin-bottom: 15px;
						line-height: 1.4;
					}

					.btn-view-more {
						padding: 8px 18px;
						font-size: 0.8rem;
					}
				}
			}
		}

		.video {
			.tab-box .right {
				min-height: auto;

				video {
					width: 100%;
					height: auto;
					max-height: 300px;
				}

				.loading-placeholder {
					width: 100%;
					height: 300px;
					background-color: #f5f5f5;
					border-radius: 8px;
					display: flex;
					align-items: center;
					justify-content: center;

					.loading-content {
						display: flex;
						flex-direction: column;
						align-items: center;
						justify-content: center;

						p {
							margin: 10px 0 0 0;
							font-size: 14px;
							color: #666;
						}
					}
				}
			}
		}
	}

	.home {
		overflow: hidden;
	}

	.w1355 {
		width: 100%;
		max-width: 1355px;
		margin: 0 auto;

		.image {
			width: 90px;
			height: 90px;
		}
	}

	.index-box {
		margin-bottom: 100px;

		.title-index {
			.w {
				background-color: #fff;
				position: relative;
				top: -105px;
			}
		}

		.w1355 {
			position: relative;
		}

		.image {
			background-color: #fff;
			display: inline-block;
			padding: 10px;
			border-radius: 50%;
		}

		ul {
			// position: absolute;
			// top: 120px;
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;
			margin-top: -110px;

			li {
				box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.09);
				width: 23%;
				text-align: center;
				padding: 50px 20px;
				box-sizing: border-box;
				transition: all 0.3s ease;
				border-top: 2px solid #409EFF;

				&:hover {
					background-color: #409EFF;

					.t {
						color: #fff;
					}

					span {
						color: #fff;
					}
				}

				.t {
					font-size: 24px;
					font-weight: bold;
					margin: 20px 0;
				}

				.item {
					display: flex;
					justify-content: space-between;
					flex-wrap: wrap;
					line-height: 32px;

					span {
						display: block;
						width: 50%;
						font-size: 16px;
						cursor: pointer;
					}
				}

				.btn {
					font-size: 16px;
					margin-top: 40px;
				}
			}
		}
	}

	.banner {
		// 使轮播容器突破父容器限制
		margin-left: calc(-50vw + 50%);
		margin-right: calc(-50vw + 50%);
		overflow: hidden;

		.carousel-container {
			position: relative;
			height: 100%;
			overflow: hidden;
			cursor: grab;
			user-select: none;
			touch-action: pan-y;

			&:active {
				cursor: grabbing;
			}

			&.dragging {
				cursor: grabbing;
			}
		}

		.carousel-wrapper {
			// padding-bottom: 28.64%;
			// height: 100%;
			position: relative;
		}

		.carousel-track {
			height: 100%;
			display: flex;
			transition: transform 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
		}

		.carousel-item {
			width: 100%;
			height: 100%;
			padding-bottom: 28.64%;
			flex-shrink: 0;
			display: flex;
			align-items: center;
			justify-content: center;
			color: #fff;
			position: relative;
			background-size: cover;
			background-position: center;
			background-repeat: no-repeat;



			// 背景遮罩层
			.banner-overlay {
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				z-index: 1;
			}

			.banner-content {
				max-width: 800px;
				text-align: center;
				z-index: 2;
				position: relative;
				padding: 0 40px;
				position: absolute;
				top: 50%;
				transform: translateY(-50%);

				h2 {
					font-size: 3.5rem;
					font-weight: 700;
					margin-bottom: 30px;
					line-height: 1.2;
					text-shadow: 0 4px 8px rgba(0, 0, 0, 0.5);
					animation: fadeInUp 1s ease-out;
				}

				p {
					font-size: 1.5rem;
					line-height: 1.6;
					opacity: 0.95;
					text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
					animation: fadeInUp 1s ease-out 0.2s both;
				}

				.btn {
					padding: 16px 40px;
					font-size: 1.2rem;
					font-weight: 600;
					border: 3px solid #fff;
					background: transparent;
					color: #fff;
					border-radius: 50px;
					transition: all 0.4s ease;
					cursor: pointer;
					text-transform: uppercase;
					letter-spacing: 1px;
					animation: fadeInUp 1s ease-out 0.4s both;

					&:hover {
						background: #fff;
						color: #333;
						transform: translateY(-3px);
						box-shadow: 0 8px 25px rgba(255, 255, 255, 0.3);
					}

					&:active {
						transform: translateY(-1px);
					}
				}
			}
		}

		// 左右控制按钮
		.carousel-controls {
			position: absolute;
			top: 50%;
			left: 0;
			right: 0;
			transform: translateY(-50%);
			display: flex;
			justify-content: space-between;
			padding: 0 40px;
			z-index: 10;
			pointer-events: none;
		}

		.carousel-btn {
			width: 60px;
			height: 60px;
			border: 2px solid rgba(255, 255, 255, 0.8);
			background: rgba(255, 255, 255, 0.1);
			color: #fff;
			border-radius: 50%;
			cursor: pointer;
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 28px;
			font-weight: bold;
			transition: all 0.3s ease;
			backdrop-filter: blur(15px);
			pointer-events: auto;

			&:hover {
				background: rgba(255, 255, 255, 0.25);
				border-color: #fff;
				transform: scale(1.1);
				box-shadow: 0 4px 20px rgba(255, 255, 255, 0.3);
			}

			&:active {
				transform: scale(0.95);
			}

			span {
				line-height: 1;
			}

			&.carousel-btn-prev {
				span {
					transform: translateX(-1px);
					transform: translateY(-2px);
				}
			}

			&.carousel-btn-next {
				span {
					transform: translateX(1px);
					transform: translateY(-2px);
				}
			}
		}

		// 指示器
		.carousel-indicators {
			position: absolute;
			bottom: 40px;
			left: 50%;
			transform: translateX(-50%);
			display: flex;
			gap: 15px;
			z-index: 10;
		}

		.indicator {
			width: 16px;
			height: 16px;
			border-radius: 50%;
			border: 2px solid rgba(255, 255, 255, 0.6);
			background: transparent;
			cursor: pointer;
			transition: all 0.3s ease;

			&.active {
				background: #fff;
				border-color: #fff;
				transform: scale(1.3);
			}

			&:hover {
				border-color: #fff;
				transform: scale(1.1);
			}
		}

		// 自动播放控制
		.carousel-auto-control {
			position: absolute;
			top: 40px;
			right: 40px;
			z-index: 10;
		}

		.auto-play-btn {
			width: 50px;
			height: 50px;
			border: 2px solid rgba(255, 255, 255, 0.8);
			background: rgba(255, 255, 255, 0.1);
			color: #fff;
			border-radius: 50%;
			cursor: pointer;
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 16px;
			transition: all 0.3s ease;
			backdrop-filter: blur(15px);

			&:hover {
				background: rgba(255, 255, 255, 0.25);
				border-color: #fff;
				transform: scale(1.05);
			}

			&.playing {
				background: rgba(76, 175, 80, 0.8);
				border-color: rgba(76, 175, 80, 1);
			}
		}
	}

	// 动画定义
	@keyframes fadeInUp {
		from {
			opacity: 0;
			transform: translateY(40px);
		}

		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	// 响应式设计
	@media (max-width: 1400px) {
		.index-box .w1355 {
			width: 90%;
		}
	}

	@media (max-width: 768px) {
		.title-index .w {
			font-size: 22px;
			padding: 30px 0;

			.t2 {
				font-size: 14px;
			}
		}

		.banner {
			.carousel-container {
				// height: 70vh;
				// min-height: 500px;
			}

			.carousel-item {
				padding-bottom: 60%;
				background-size: cover !important;

				.banner-content {
					padding: 0 20px;

					h2 {
						font-size: 2rem;
						margin-bottom: 1rem;
					}

					p {
						font-size: 1rem;
					}

					.btn {
						padding: 14px 30px;
						font-size: 1rem;
					}
				}
			}

			.carousel-controls {
				padding: 0 20px;
				display: none;
			}

			.carousel-btn {
				width: 50px;
				height: 50px;
				font-size: 24px;
			}

			.carousel-auto-control {
				top: 20px;
				right: 20px;
			}

			.auto-play-btn {
				width: 45px;
				height: 45px;
				font-size: 14px;
			}

			.carousel-indicators {
				bottom: 30px;
			}
		}

		.index-box {
			.title-index .w {
				top: 0;
			}

			ul {
				overflow-x: auto;
				display: block;
				white-space: nowrap;
				padding: 10px;
				margin-top: 0px;
			}

			ul li {
				width: 260px;
				display: inline-block;
				margin-right: 20px;
				padding: 20px;
				box-sizing: border-box;

				&:last-child {
					margin-right: 0;
				}

				.t {
					font-size: 18px;
					margin: 10px 0;
				}

				.btn {
					margin-top: 15px;
				}
			}
		}
	}

	@media (max-width: 480px) {
		.banner {
			.carousel-container {
				// height: 60vh;
				// min-height: 400px;
			}

			.carousel-item {
				.banner-content {
					h2 {
						font-size: 2rem;
					}

					p {
						font-size: 1.1rem;
					}
				}
			}

			.carousel-controls {
				padding: 0 15px;
			}

			.carousel-btn {
				width: 45px;
				height: 45px;
				font-size: 20px;
			}
		}

		/* 视频部分响应式样式 */
		.video .tab-box .right .no-video-placeholder {
			height: 300px;
		}

		.video .tab-box .right .no-video-placeholder p {
			font-size: 14px;
		}
	}

	.features {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
		gap: 30px;
	}

	.feature-card {
		background: #fff;
		padding: 30px;
		border-radius: $border-radius-base * 2;
		box-shadow: $box-shadow-base;
		text-align: center;

		h3 {
			color: $primary-color;
			margin-bottom: 15px;
		}

		p {
			color: #666;
			line-height: 1.6;
		}
	}

	/* 图片轮播样式 */

	.image-carousel-container {
		width: 100%;
		max-width: 1200px;
		overflow: hidden;
		position: relative;
		margin: 20px auto;
		will-change: transform;
	}

	.image-carousel-track {
		display: flex;
		width: max-content;
		will-change: transform;
		animation: marquee 40s linear infinite;
	}

	.image-carousel-item {
		flex: 0 0 auto;
		width: 220px;
		/* 固定宽度220px，5张图片约1100px */
		margin-right: 20px;

		img {
			width: 100%;
			height: 165px;
			/* 保持4:3比例 (220px * 3/4) */
			object-fit: cover;
			border-radius: 8px;
			box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
			opacity: 0;
			transition: opacity .3s ease;
			backface-visibility: hidden;
			transform: translateZ(0);
			will-change: opacity;
		}
	}

	/* 图片加载完成后淡入显示 */
	.image-carousel-item img.loaded {
		opacity: 1;
	}

	/* 合作伙伴轮播样式 */
	.partner-carousel-container {
		width: 100%;
		max-width: 1200px;
		overflow: hidden;
		position: relative;
		margin: 20px auto;
		will-change: transform;
	}

	.partner-carousel-track {
		display: flex;
		width: max-content;
		will-change: transform;
		animation: marquee 40s linear infinite;
	}

	/* 悬停时暂停动画 */
	.image-carousel-container:hover .image-carousel-track {
		animation-play-state: paused;
	}

	.partner-carousel-container:hover .partner-carousel-track {
		animation-play-state: paused;
	}

	@keyframes marquee {
		0% {
			transform: translateX(0);
		}

		100% {
			transform: translateX(-50%);
		}
	}

	.partner-carousel-item {
		flex: 0 0 auto;
		width: 180px;
		/* 固定宽度确保一屏显示6个 */
		margin-right: 20px;
		position: relative;
	}

	.partner-image-wrapper {
		position: relative;
		width: 100%;
		padding-bottom: 44.44%;
		/* 4:9比例 */
		overflow: hidden;
		border-radius: 8px;
		box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
	}

	.partner-image-wrapper img {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		object-fit: cover;
		opacity: 0;
		transition: opacity .3s ease;
		backface-visibility: hidden;
		transform: translateZ(0);
		will-change: opacity;
	}

	.partner-image-wrapper img.loaded {
		opacity: 1;
	}

	/* 加载状态样式 */
	.loading-overlay {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(255, 255, 255, 0.8);
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 9999;
	}

	.loading-placeholder {
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #f5f5f5;
		border-radius: 8px;
	}

	.loading-content {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 20px;
	}

	.spinner {
		width: 40px;
		height: 40px;
		border: 4px solid #f3f3f3;
		border-top: 4px solid #185a9d;
		border-radius: 50%;
		animation: spin 1s linear infinite;
		margin-bottom: 15px;
	}

	@keyframes spin {
		0% {
			transform: rotate(0deg);
		}

		100% {
			transform: rotate(360deg);
		}
	}

	.loading-placeholder .loading-content p {
		margin: 0;
		font-size: 16px;
		color: #666;
	}

	.loading-placeholder .spinner {
		width: 30px;
		height: 30px;
		border-width: 3px;
	}

	/* 无视频内容提示样式 */
	.no-video-placeholder {
		width: 100%;
		height: 600px;
		background-color: #f5f5f5;
		border-radius: 8px;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.no-video-placeholder p {
		margin: 0;
		font-size: 18px;
		color: #666;
	}
</style>

<style>
	/* 全局定义，确保内联 animation: marquee ... 能找到关键帧 */
	@keyframes marquee {
		0% {
			transform: translateX(0);
		}

		100% {
			transform: translateX(-50%);
		}
	}

	/* 悬停时强制暂停，提升优先级避免被内联样式影响 */
	.image-carousel-container:hover .image-carousel-track {
		animation-play-state: paused !important;
	}

	.partner-carousel-container:hover .partner-carousel-track {
		animation-play-state: paused !important;
	}
</style>